export const TOASTER_NAMESPACE = {
  ADD_SUCCESS: 'Added Successfully!',
  FAILED_TO_ADD_RECORD: 'Failed to Add Record',
  EDIT_SUCCESS: 'Updated Successfully!',
  FAILED_TO_EDIT_RECORD: 'Failed to Edit Record',
  ENTER_VALID_DETAILS: 'Please enter valid details!',
  LAYOUT_NOT_CREATED: 'Layout not created for this entity',
  PERMISSION_DENIED:
    'You do not have the required permissions to perform this action.',
  SAVE_SUCCESS: 'Saved Successfully!',
  DRAFT_SAVE_SUCCESS: 'Draft Saved Successfully!',
  PATIENT_ALREADY_ENROLLED: 'Patient is already enrolled for Copay Program',
  NO_CHANGES_TO_SAVE: 'No changes to save',
  CASE_MOVED_TO_EXCEPTION_STATUS:
    'Case has now been routed for exception review process',
  NO_PATIENT_FOUND: 'No patient found for this case',
  SELECT_PRODUCT: 'Please select a valid product',
}
